import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledSvg = styled.svg `
  fill: ${({ $inverted = false }) => $inverted ? theme.semantic.foreground.inverse : theme.semantic.foreground.primary};
`;
